"use client"

import SvgIcon from '@components/shared/svg-icons/SvgIcon'

import styles from './StripNav.module.css'

// Przyciski przewijania pasa kart (od 640 px); na dotyku pas przewija się palcem.
export default function StripNav ({ controls, labelNext = 'Następne oferty', labelPrev = 'Poprzednie oferty' }) {
    const scroll = (direction) => {
        const strip = document.getElementById(controls)
        if (!strip) return
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        strip.scrollBy({ left: direction * strip.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' })
    }

    return (
        <div className={styles.nav}>
            <button aria-controls={controls} aria-label={labelPrev} className={styles.btn} onClick={() => scroll(-1)} type="button">
                <SvgIcon name="chev-l" />
            </button>
            <button aria-controls={controls} aria-label={labelNext} className={styles.btn} onClick={() => scroll(1)} type="button">
                <SvgIcon name="chev" />
            </button>
        </div>
    )
}
